import React from 'react';
import { Button } from 'rsuite';

const ScheduleItem = ({ 
    item, 
    date, 
    canManage, 
    getColorForType, 
    onDragStart, 
    onRemove, 
    showRemoveButton = true,
    isPopover = false 
}) => {

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            padding: isPopover ? '2px 0' : '0'
        }}>
            <span
                draggable={canManage}
                onDragStart={(e) => onDragStart(e, item, date)}
                style={{ 
                    cursor: canManage ? 'move' : 'default',
                    userSelect: 'none',
                    backgroundColor: getColorForType(item.type_id),
                    color: 'white',
                    padding: '2px 4px',
                    borderRadius: '3px',
                    fontSize: '11px',
                    maxWidth: isPopover ? 'none' : '150px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}
                title={`${item.user_name} (${item.type_name}) ${item.time_range}`}
            >
                {isPopover 
                    ? `${item.user_name} (${item.type_name}) ${item.time_range}` 
                    : `${item.user_name} (${item.type_name})`
                }
            </span>
            {canManage && showRemoveButton && (
                <Button
                    size="xs"
                    color="red"
                    appearance="subtle"
                    onClick={() => onRemove(item.id, date)}
                >
                    {isPopover ? '移除' : '×'}
                </Button>
            )}
        </div>
    );
};

export default ScheduleItem;
